<script>
export default {
  name: 'SettleSetting',
  props: {
    id: {
      type: String
    },
    dataForm: {
      type: Object
    },
    isEditor: {
      type: Boolean,
      default: false
    },
    detailMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 红人结算信息相关数据
      settlementData: [],
      settlementDialogVisible: false,
      settlementDialogTitle: '添加红人结算信息',
      settlementLoading: false,
      payPlatform: {
        0: '银行卡',
        1: '支付宝'
      },
      settlementForm: {
        id: null,
        pay_platform: '',
        platform: 0,
        payment_target: '',
        payment_account: '',
        bank_name: '',
        settle_method: 'corporate',
        invoice_type: 'normal',
        tax_point: '1.00'
      },
      settlementRules: {
        platform: [
          { required: true, message: '请选择支付平台', trigger: 'change' }
        ],
        payment_target: [
          { required: true, message: '请输入支付对象', trigger: 'blur' }
        ],
        payment_account: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ]
      },
      currentEditIndex: -1,
      optionMaps: {
        settle_method: { 'corporate': '对公', 'private': '个人' },
        invoice_type: { 'normal': '普通发票', 'special': '专用发票' }
      }
    }
  },
  methods: {
    async handleGetArtistPaymentList() {
      const artist_id = this.id
      if (artist_id) {
        const { list } = await this.$api.getArtistPayments({ artist_id: artist_id })
        this.settlementData = [...list]
      }

    },
    // 红人结算信息相关方法
    async showSettlementDialog() {
      this.settlementDialogTitle = '添加红人结算信息'
      this.settlementForm = {
        platform: 0,
        payment_target: '',
        payment_account: '',
        bank_name: '',
        settle_method: 'corporate',
        invoice_type: 'normal',
        tax_point: '1.00'
      }
      this.currentEditIndex = -1
      this.settlementDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.settlementFormRef) {
          this.$refs.settlementFormRef.clearValidate()
        }
      })
    },
    handlePlatformChange(value) {
      // 当选择支付宝时，清空开户行
      if (value === 'alipay') {
        this.settlementForm.bank_name = ''
      }
    },

    editSettlement(row, index) {
      this.settlementDialogTitle = '编辑红人结算信息'
      this.settlementForm = { ...row }
      this.currentEditIndex = index
      this.settlementDialogVisible = true
    },

    deleteSettlement(index, row) {
      this.$confirm('确定删除这条结算信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (row && row.id) {
          await this.$api.deleteArtistPaymentRecord([row.id])
        }
        const delIndex = this.settlementData.findIndex(value => value.id === row.id)
        this.settlementData.splice(delIndex, 1)

        this.msgSuccess('删除成功')
      }).catch(() => {
        // 取消删除
      })
    },

    saveSettlement() {
      this.$refs.settlementFormRef.validate(async (valid) => {
        if (valid) {
          this.settlementLoading = true

          // 如果是支付宝，不需要开户行验证
          if (this.settlementForm.platform === 'alipay') {
            this.settlementForm.bank_name = ''
          }
          const nowTime = this.$utils.getCurrentTime()

          this.settlementForm.pay_platform = this.payPlatform[this.settlementForm.platform] || ''
          if (!this.settlementForm.id) {
            // 添加新记录
            // console.log('settlementForm',this.settlementForm)
            const id = await this.$api.saveArtistPaymentRecord(this.settlementForm, {
              artist_id: this.dataForm.artist_id,
              nickname: this.dataForm.nickname || ''
            })
            //新增插入到第一行
            this.settlementData.unshift({
              ...this.settlementForm, ...{
                id: id,
                created_at: nowTime,
                updated_at: nowTime
              }
            })
            this.msgSuccess('添加成功')
          } else {
            // 编辑现有记录
            await this.$api.saveArtistPaymentRecord(this.settlementForm, {
              artist_id: this.dataForm.artist_id,
              nickname: this.dataForm.nickname || ''
            })
            this.currentEditIndex = this.settlementData.findIndex(value => value.id === this.settlementForm.id)
            this.settlementData.splice(this.currentEditIndex, 1, { ...this.settlementForm, ...{ updated_at: nowTime } })
            this.msgSuccess('修改成功')
          }

          this.settlementLoading = false
          this.settlementDialogVisible = false
        } else {
          return false
        }
      })
    },
    rateFormat(num) {
      return this.$utils.numberFormat(num, 0)
    }
  },
  mounted() {
    this.handleGetArtistPaymentList()
  }
}
</script>

<template>
  <div>
    <div :class="detailMode ? 'card-panel detail-settle-panel' : 'theme-border card-panel'">
      <div class='card-header' v-if='!detailMode'>
        <div></div>
        <div>
          <h3 @click='handleGetArtistPaymentList'>红人（{{ dataForm.nickname || '-' }}）结算信息</h3>
        </div>
        <div>
          <el-button type='primary' v-if='isEditor' size='mini' @click='showSettlementDialog'>
            <i class='el-icon-plus'></i> 添加结算信息
          </el-button>
        </div>

      </div>
      <div>
        <el-table
          :data='settlementData'
          border
          size='mini'
          :default-sort="detailMode ? {} : {prop: 'updated_at', order: 'descending'}"
          highlight-current-row
          stripe
        >
          <el-table-column type='index' label='序号' width='80' align='center'></el-table-column>
          <el-table-column
            prop='platform'
            label='支付平台'
            min-width='110'
            align='center'
            header-align='center'>
            <template slot-scope='{row}'>
              <span>{{ row.pay_platform || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop='payment_target'
            label='支付对象'
            min-width='110'
            align='center'
            header-align='center'>
          </el-table-column>
          <el-table-column
            prop='payment_account'
            label='账号'
            min-width='200'
            align='center'
            header-align='center'>
          </el-table-column>
          <el-table-column
            prop='bank_name'
            label='开户行'
            align='center'
            min-width='110'
            header-align='center'>
          </el-table-column>

          <el-table-column
            prop='settle_method'
            label='结算方式'
            align='center'
            header-align='center'>
            <template slot-scope='{row}'>
              <span>{{ optionMaps['settle_method'][row.settle_method] || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop='invoice_type'
            label='发票类型'
            align='center'
            header-align='center'>
            <template slot-scope='{row}'>
              <span>{{ optionMaps['invoice_type'][row.invoice_type] || '' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop='tax_point'
            label='票面税点'
            align='center'
            header-align='center'>
            <template slot-scope='{row}'>
              <span class='rate'>{{ rateFormat(row.tax_point) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop='updated_at'
            label='修改时间'
            align='center'
            width='160'
            :sortable='!detailMode'
            header-align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-time'></i>
              <span style='margin-left: 10px'>{{ scope.row.updated_at }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label='操作'
            width='120'
            align='center'
            v-if='isEditor'
            header-align='center'>
            <template slot-scope='scope'>
              <template v-if='detailMode'>
                <el-button type='text' size='mini' @click='editSettlement(scope.row, scope.$index)'>编辑</el-button>
                <el-button type='text' size='mini' @click='deleteSettlement(scope.$index,scope.row)'>删除</el-button>
              </template>
              <template v-else>
                <el-button type='text' size='mini' icon='el-icon-edit' @click='editSettlement(scope.row, scope.$index)'>编辑</el-button>
                <el-button type='text' size='mini' icon='el-icon-close' @click='deleteSettlement(scope.$index,scope.row)'>删除</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 红人结算信息弹框 -->
    <el-dialog
      :title='settlementDialogTitle'
      :visible.sync='settlementDialogVisible'
      width='600px'
      :close-on-click-modal='false'>
      <el-form
        :model='settlementForm'
        :rules='settlementRules'
        ref='settlementFormRef'
        label-width='100px'
        size='mini'>
        <el-form-item label='支付平台' prop='platform'>
          <el-select v-model='settlementForm.platform' placeholder='请选择支付平台' style='width: 100%'
                     @change='handlePlatformChange'>
            <el-option label='银行卡' :value='0'></el-option>
            <el-option label='支付宝' :value='1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='支付对象' prop='payment_target'>
          <el-input v-model='settlementForm.payment_target' placeholder='请输入支付对象姓名' maxlength='50'
                    show-word-limit />
        </el-form-item>
        <el-form-item label='账号' prop='payment_account'>
          <el-input v-model='settlementForm.payment_account' placeholder='请输入银行账号或支付宝账号' maxlength='50'
                    show-word-limit />
        </el-form-item>
        <el-form-item label='开户行' prop='bank_name' v-if='settlementForm.platform === 0'>
          <el-input v-model='settlementForm.bank_name' placeholder='请输入开户行名称' maxlength='50' show-word-limit />
        </el-form-item>
        <el-form-item label='结算方式' prop='settle_method'>
          <el-select v-model='settlementForm.settle_method' placeholder='请选择结算方式' clearable
                     style='width: 100%'>
            <el-option label='对公' value='corporate' />
            <el-option label='个人' value='private' />
          </el-select>
        </el-form-item>
        <el-form-item label='发票类型' prop='invoice_type'>
          <el-select v-model='settlementForm.invoice_type' placeholder='请选择发票类型' clearable
                     style='width: 100%'>
            <el-option label='普通发票' value='normal' />
            <el-option label='专用发票' value='special' />
          </el-select>
        </el-form-item>
        <el-form-item label='票面税点' prop='tax_point'>
          <el-select v-model='settlementForm.tax_point' placeholder='请选择票面税点' clearable
                     style='width: 100%'>
            <el-option label='1%' value='1.00' />
            <el-option label='3%' value='3.00' />
            <el-option label='6%' value='6.00' />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='settlementDialogVisible = false' size='small'>取消</el-button>
        <el-button type='primary' @click='saveSettlement' size='small' :loading='settlementLoading'
                   :disabled='settlementLoading'>{{ !this.settlementForm.id ? '确认' : '保存' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.sign-card {
  margin-bottom: 20px;
}

.card-panel {
  padding: 10px;
}

.card-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-bottom: #f2f2f2 1px solid;
  margin-bottom: 8px;
}
</style>
